import React from 'react';
import {
  Grid,
  Table,
  TableBody,
  Typography,
  makeStyles
} from '@material-ui/core';
import { FieldArrayRenderProps } from 'formik';
import Customer from './Customer';

const useStyles = makeStyles({
  addCustomer: {
    cursor: 'pointer',
    borderRadius: '5px',
    '& span': {
      fontSize: '0.7rem'
    }
  },
  body: {
    marginTop: '1rem'
  },
  btnContainer: {
    width: '100%',
    height: '36px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  '@global': {
    '.MuiTable-root': {
      borderRadius: 0
    }
  }
});

const Customers = ({ form, remove, replace }: FieldArrayRenderProps) => {
  const classes = useStyles();
  const { customers } = form.values;

  return (
    <Grid item xs={12}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          Client(s)
        </Typography>
      </div>
      <Table>
        <TableBody className={classes.body}>
          {customers.map((field: any, index: number) => (
            <Customer
              key={field.id}
              index={index}
              disabled={!!field.intelligent_office_id}
              removeCustomer={() => remove(index)}
              onChange={(e: any, key: any) => {
                const customer = field;
                (customer[key] as any) = e;
                replace(index, customer);
              }}
            />
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default Customers;
